import { makeAutoObservable, runInAction } from "mobx";

/**
 * Tracks in-flight Cloud Run transcription jobs so the UI can show a global footer progress bar
 * and disable per-recording duplicate requests.
 */
class TranscriptionJobsStoreImpl {
  /** jobId -> recordingId */
  jobs = new Map<string, string>();

  constructor() {
    makeAutoObservable(this);
  }

  get activeCount(): number {
    return this.jobs.size;
  }

  hasJobForRecording(recordingId: string): boolean {
    for (const rid of this.jobs.values()) {
      if (rid === recordingId) return true;
    }
    return false;
  }

  beginJob(jobId: string, recordingId: string) {
    runInAction(() => {
      this.jobs.set(jobId, recordingId);
    });
  }

  endJob(jobId: string) {
    runInAction(() => {
      this.jobs.delete(jobId);
    });
  }
}

const transcriptionJobsStore = new TranscriptionJobsStoreImpl();
export default transcriptionJobsStore;
